import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import StoreIcon from "@mui/icons-material/Store";
import WidgetsIcon from "@mui/icons-material/Widgets";
import HomeIcon from "@mui/icons-material/Home";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";

// Flat sidebar route list. { type: "divider" } items render a visual separator.
export const appRoutes = [
  {
    name: "Home",
    to: "/home",
    icon: <HomeIcon />,
    role: "admin",
  },
  {
    name: "Floor Plans",
    to: "/floorPlans",
    icon: <WidgetsIcon />,
    role: "admin",
  },
  {
    name: "Users",
    to: "/users",
    icon: <PersonOutlineIcon />,
    role: "admin",
  },
  {
    name: "API Keys",
    to: "/api-keys",
    icon: <VpnKeyOutlinedIcon />,
    role: "admin",
  },
  {
    name: "Affiliate Products",
    to: "/affiliate-products",
    icon: <StoreIcon />,
    role: "admin",
  },
  { type: "divider" },
  {
    name: "Partners",
    to: "/partners",
    icon: null,
    role: "admin",
  },
  {
    name: "Partner Analytics",
    to: "/analytics",
    icon: null,
    role: "admin",
  },
  {
    name: "Layouts",
    to: "/layouts",
    icon: null,
    role: "admin",
  },
  {
    name: "Packages",
    to: "/packages",
    icon: null,
    role: "admin",
  },
  {
    name: "Logs",
    to: "/logs",
    icon: null,
    role: "admin",
  },
  { type: "divider" },
  {
    name: "Connection Points",
    to: "/connectionPoints",
    icon: null,
    role: "admin",
  },
  {
    name: "Vibes",
    to: "/vibes",
    icon: null,
    role: "admin",
  },
  { type: "divider" },
];
